import { createSelector } from 'reselect';
import { getFilterDaysBy, getSelectedDay } from '../userInteractions/selectors';
import { getStartTime } from 'store/reducers/appointment/selectors';

// date-fns
import { parse as parseDate } from 'date-fns';

import { toISODate } from 'utils/string';

export const getAvailableTimes = state => state.availableTimes;

export const getAvailableDays = createSelector(
  getAvailableTimes,
  times => (times ? times.Days : null)
);

export const getFilteredAvailableDays = createSelector(
  getAvailableDays,
  getFilterDaysBy,
  (availableDays, filterDaysBy) => {
    if (availableDays) {
      const availableDaysCopy = [];
      let i;
      if (!filterDaysBy) {
        return availableDays;
      }
      for (i = 0; i < availableDays.length; i += 1) {
        if (availableDays[i].timeslots) {
          availableDaysCopy.push({
            ...availableDays[i],
            timeslots: availableDays[i].timeslots.filter(
              ({ time }) =>
                filterDaysBy === 'morning'
                  ? time < '12:00:00'
                  : time >= '12:00:00'
            )
          });
        }
      }
      return availableDaysCopy;
    } else {
      return [];
    }
  }
);

export const getMonthDate = createSelector(getAvailableDays, availableDays => {
  if (availableDays && availableDays.length > 0) {
    return parseDate(`${availableDays[0].calendarDate}T00:00:00`);
  }
  return null;
});

export const getCalendarSelectedDate = createSelector(
  getFilteredAvailableDays,
  getStartTime,
  getSelectedDay,
  (filteredAvailableDays, startTime, selectedDay) => {
    let selectedDateStr;
    let day;
    if (startTime && !selectedDay) {
      // find if exist startTime in availableDays
      selectedDateStr = toISODate(startTime);
      day = filteredAvailableDays.find(
        ({ calendarDate }) => calendarDate === selectedDateStr
      );
      if (day && day.isOpen && day.timeslots && day.timeslots.length > 0) {
        return { forceUpdate: false, date: startTime };
      } else {
        return { forceUpdate: true, date: null };
      }
    }
    if (selectedDay) {
      if (selectedDay.calendarDate === toISODate(startTime)) {
        return { forceUpdate: false, date: startTime };
      }
      // check if selectedDay exist in availableDays
      selectedDateStr = selectedDay && selectedDay.calendarDate;
      day = filteredAvailableDays.find(
        ({ calendarDate }) => calendarDate === selectedDateStr
      );
      if (day && day.isOpen && day.timeslots && day.timeslots.length > 0) {
        return {
          forceUpdate: false,
          date: parseDate(`${selectedDay.calendarDate}T00:00:00`)
        };
      }
    }
    // find if exist startTime in availableDays
    selectedDateStr = toISODate(startTime);
    day = filteredAvailableDays.find(
      ({ calendarDate }) => calendarDate === selectedDateStr
    );
    if (day && day.isOpen && day.timeslots && day.timeslots.length > 0) {
      return { forceUpdate: false, date: startTime };
    }
    // find firstAvailableDate
    day = filteredAvailableDays.find(
      ({ timeslots }) => !!(timeslots && timeslots.length > 0)
    );
    return {
      forceUpdate: !!startTime,
      date: day ? parseDate(`${day.calendarDate}T00:00:00`) : null
    };
  }
);

const getTimeslotsAsDates = (timeslots, dateStr) => {
  const result = [];
  if (timeslots) {
    timeslots.forEach(timeslot =>
      result.push({
        teamIds: timeslot.teamIds,
        time: parseDate(`${dateStr}T${timeslot.time}`)
      })
    );
  }
  return result;
};

export const getAvailableDay = createSelector(
  getAvailableDays,
  availableDays => selectedDate => {
    if (availableDays && selectedDate) {
      let dateString = selectedDate;
      if (selectedDate instanceof Date) {
        dateString = toISODate(selectedDate);
      }
      const day = availableDays.find(day => day.calendarDate === dateString);
      if (day && day.isOpen && day.timeslots && day.timeslots.length > 0) {
        return day;
      }
    }
    return null;
  }
);

export const getTimeslotsBySelectedDate = createSelector(
  getSelectedDay,
  day => {
    if (day) {
      const morning = getTimeslotsAsDates(
        day.timeslots.filter(timeslot => timeslot.time < '12:00:00'),
        day.calendarDate
      );
      const afternoon = getTimeslotsAsDates(
        day.timeslots.filter(timeslot => timeslot.time >= '12:00:00'),
        day.calendarDate
      );
      return { morning, afternoon };
    }
    return { morning: [], afternoon: [] };
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/availableTimes/selectors.js